<page-heading
  [title]="('integrations.agendorForm.heading' | translate)"
  [description]="
    isNew
      ? ('integrations.agendorForm.descriptionNew' | translate)
      : ('integrations.agendorForm.descriptionEdit' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

@if (loadingContent) {
<content-loading-list />
}

<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'integrations.agendorForm.configNameLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="255"
                formControlName="name"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="('integrations.agendorForm.nameFieldLabel' | translate)"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 mb-3">
              <div class="position-relative" formGroupName="metadata">
                <label class="form-label">{{ 'integrations.agendorForm.tokenLabel' | translate }}</label>
                <input
                  [type]="hideAllPasswords ? 'password' : 'text'"
                  class="form-control"
                  maxlength="255"
                  formControlName="token"
                  [placeholder]="'integrations.agendorForm.tokenPlaceholder' | translate"
                  required
                />

                <field-error-component
                  [field]="'metadata.token'"
                  [label]="('integrations.agendorForm.tokenFieldLabel' | translate)"
                  [formGroup]="formGroup"
                />
                <i
                  class="bi icon-eye"
                  [ngClass]="hideAllPasswords ? 'bi-eye-slash' : 'bi-eye'"
                  (click)="togglePasswordVisibility()"
                ></i>
              </div>
              <span class="text-muted mt-1">
                {{ 'integrations.agendorForm.tokenHelp' | translate }}
              </span>
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4">
    <button class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'integrations.agendorForm.cancelButton' | translate }}
    </button>

    <button class="btn btn-primary" [disabled]="!formGroup.valid || loading">
      {{ loading ? ('integrations.agendorForm.savingButton' | translate) : ('integrations.agendorForm.saveButton' | translate) }}
      @if (loading) {
      <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
      }
    </button>
  </div>
</div>
